var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-layout',[_c('login-main',{on:{"loginSuccess":_vm.loginSuccessHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }